enum InsertTypes {
	Above = 'above',
	Below = 'below'
}

export default InsertTypes
